import React from 'react';
import { sharedInFeed, sendInMessenger } from '../../../utils/fb';
import { useScript } from '../../../utils/hooks';
import { CopyShared } from './CopyShared';
import { EmailShared } from './EmailShared';
import { FacebookShared } from './FacebookShared';
import { WhatsAppShared } from './WhatsAppShared';

interface SharedToWhatsApp {
  numberPhone: string;
  message: string;
}
interface MailToProps {
  mail: string;
  message: string;
  subject: string;
}
interface DataShareProps {
  link: string;
  mailTo: MailToProps;
  sharedToWhatsApp: SharedToWhatsApp;
}
interface Props {
  dataShare: DataShareProps;
}
export const SharedItems = ({ dataShare }: Props) => {
  const sharedLink = typeof window !== 'undefined' ? window.location.href : '';
  const sdk = String(process.env.SDK_FACEBOOK);
  const [loaded, error] = useScript(sdk);
  const { link, mailTo, sharedToWhatsApp } = dataShare;

  const handleSharedFeed = () => {
    if (loaded && !error) {
      sharedInFeed(link);
    }
  };
  const handleSharedMessenger = () => {
    if (loaded && !error) {
      sendInMessenger(link);
    }
  };
  return (
    <ul className="list ma0 pa0">
      <FacebookShared
        sharedLink={link}
        typeShared="Facebook"
        icon="SvgIconFacebook"
        onClick={handleSharedFeed}
      />
      <FacebookShared
        sharedLink={link}
        typeShared="Messenger"
        icon="SvgIconMessenger"
        onClick={handleSharedMessenger}
      />
      <WhatsAppShared sendToWhatsApp={sharedToWhatsApp} />
      <EmailShared mailTo={mailTo} />
      <CopyShared sharedLink={sharedLink} />
    </ul>
  );
};
